import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/platform/page.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/platform/voice-ai/VoiceTeaser.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/pricing/components/PricingOfferButton.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/CookiePreferences.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Disclosure"] */ "/work/repo/redesign/components/Disclosure.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/Experience.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/Message.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/PlatformBackground.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/PlatformFeaturePage.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/PlatformOmnichannelHero.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/ProductVisual.jsx");
